export const types = {
    GET_USER_AGENCIES_REQUEST: 'userInfo/GET_USER_AGENCIES_REQUEST',
    GET_USER_AGENCIES_SUCCESS: 'userInfo/GET_USER_AGENCIES_SUCCESS',
    GET_USER_AGENCIES_ERROR: 'userInfo/GET_USER_AGENCIES_ERROR',

    CLEAR_USER_AGENCIES: 'userInfo/CLEAR_USER_AGENCIES',

    GET_ALL_CITIES_REQUEST: 'userInfo/GET_ALL_CITIES_REQUEST',
    GET_ALL_CITIES_SUCCESS: 'userInfo/GET_ALL_CITIES_SUCCESS',
    GET_ALL_CITIES_ERROR: 'userInfo/GET_ALL_CITIES_ERROR',

    SET_SELECTED_JURISDICTION: 'userInfo/SET_SELECTED_JURISDICTION',
};
